/**
 * Datadog Browser Logs initialization for studio.
 * Initializes only when VITE_STUDIO_DD_CLIENT_TOKEN is set (e.g. staging/production).
 * No-op in local development.
 */
import { datadogLogs } from "@datadog/browser-logs";

const clientToken = import.meta.env.VITE_STUDIO_DD_CLIENT_TOKEN as string | undefined;
const env = (import.meta.env.VITE_CONTEXT as string) || "local";

if (clientToken && env !== "local") {
  datadogLogs.init({
    clientToken,
    env,
    site: "us5.datadoghq.com",
    service: "studio",
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    beforeSend: (event) => {
      // drop aborted/canceled network requests (user navigation, tab close, ad blockers)
      if (event.http && event.http.status_code === 0) {
        return false;
      }
      // drop known-benign browser noise
      if (event.message.includes("ResizeObserver loop")) {
        return false;
      }
      // Twilio Voice SDK network-flap noise (backgrounded tabs, wifi changes) — self-recovering
      if (event.message.includes("[TwilioVoice]") && (event.message.includes("ConnectionError") || event.message.includes("websocket close"))) {
        return false;
      }
      if (event.error?.stack?.includes("chrome-extension://") || event.error?.stack?.includes("moz-extension://")) {
        return false;
      }
      return true;
    }
  });
}
